
/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'sanitize.css/sanitize.css';

// Import root app
import App from 'containers/App';

// Load the favicon and the .htaccess file
import '!file-loader?name=[name].[ext]!./images/favicon.ico';
import 'file-loader?name=[name].[ext]!./.htaccess';

import configureStore from './configureStore';

// Import i18n messages
import { translationMessages } from './i18n';

// Import CSS reset and Global Styles
import GlobalStyle from './global-styles';
import { setStore as setReducerStore } from './utils/injectReducer';
import { setStore as setSagaStore } from './utils/injectSaga';

if (typeof globalThis !== 'undefined' && process.env.NODE_ENV !== 'test') {
  globalThis.IS_REACT_ACT_ENVIRONMENT = false;
}

// Create redux store
const initialState = {};
const store = configureStore(initialState);

// Set the global store reference for dynamic reducer and saga injection
setReducerStore(store);
setSagaStore(store);

const render = (messages) => {
  try {
    const MOUNT_NODE = document.getElementById('app');

    if (!MOUNT_NODE) {
      console.error('ERROR: Could not find #app element!');
      return;
    }

    console.log('[render] Creating root...');
    const root = createRoot(MOUNT_NODE);

    console.log('[render] Calling root.render()...');
    root.render(
      <Provider store={store}>
        <BrowserRouter>
          <GlobalStyle />
          <App />
        </BrowserRouter>
      </Provider>,
    );
    console.log('[render] root.render() completed successfully');
  } catch (error) {
    console.error('[render] Caught error:', error);
    console.error('[render] Stack:', error.stack);
  }
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  // Disabled for debugging
  // module.hot.accept(['containers/App'], () => {
  //   console.log('HMR: App module updated, re-rendering...');
  //   render(translationMessages);
  // });
}

// Render the app directly - Intl API is natively supported in all modern browsers
render(translationMessages);

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
// NOTE: offline-plugin is disabled in webpack config
// if (process.env.NODE_ENV === 'production') {
//   OfflinePluginRuntime.install({
//     onUpdateReady: () => {
//       // Tells to new SW to take control immediately
//       OfflinePluginRuntime.applyUpdate();
//     },
//   });
// }
